import { c as _c } from "react/compiler-runtime";
import { tv } from 'tailwind-variants';
import type { VariantProps } from 'tailwind-variants';
const alert = tv({
  base: `
    relative
    grid
    w-full
    grid-cols-[0_1fr]
    items-start gap-y-0.5
    rounded-lg
    border
    px-6
    py-4
    text-sm
    has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr]
    has-[>svg]:gap-x-3
    [&>svg]:size-4
    [&>svg]:translate-y-0.5
    [&>svg]:text-current
  `,
  variants: {
    variant: {
      default: `
        bg-background-secondary
        text-content-primary
        border-border-tag-default
      `,
      info: `
        bg-background-accent-light
        text-content-accent-dark
        border-border-tag-accent
        *:data-[slot=alert-description]:text-content-accent-dark
        dark:bg-background-accent-dark
        dark:text-content-accent-light
        *:dark:data-[slot=alert-description]:text-content-accent-light
      `,
      destructive: `
        bg-background-negative-light
        text-content-negative-dark
        border-border-tag-negative
        *:data-[slot=alert-description]:text-content-negative-dark
        dark:bg-background-negative-dark
        dark:text-content-negative-light
        dark:border-border-tag-negative
        *:dark:data-[slot=alert-description]:text-content-negative-light
        [&>svg]:text-current
      `,
      positive: `
        bg-background-positive-light
        text-content-positive-dark
        border-border-tag-positive
        *:data-[slot=alert-description]:text-content-positive-dark
        *:dark:data-[slot=alert-description]:text-content-positive-light
        dark:text-content-positive-light
        dark:bg-background-positive-dark
        dark:border-border-tag-positive
        [&>svg]:text-current
      `,
      warning: `
        bg-background-warning-light
        text-content-warning-dark
        border-border-warning
        *:data-[slot=alert-description]:text-content-warning-dark
        *:dark:data-[slot=alert-description]:text-content-warning-light
        dark:text-content-warning-light
        dark:bg-background-warning-dark
        [&>svg]:text-current
      `
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});

// ALERT
function Alert(t0) {
  const $ = _c(10);
  let className;
  let props;
  let variant;
  if ($[0] !== t0) {
    ({
      className,
      variant,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = variant;
  } else {
    className = $[1];
    props = $[2];
    variant = $[3];
  }
  let t1;
  if ($[4] !== className || $[5] !== variant) {
    t1 = alert({
      className,
      variant
    });
    $[4] = className;
    $[5] = variant;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== props || $[8] !== t1) {
    t2 = <div className={t1} data-slot="alert" role="alert" {...props} />;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}

// ALERT TITLE
const alertTitle = tv({
  base: `
    col-start-2
    line-clamp-1
    min-h-4
    font-medium
    tracking-tight
  `
});
function AlertTitle(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = alertTitle({
      className
    });
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <div className={t1} data-slot="alert-title" {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}

// ALERT DESCRIPTION
const alertDescription = tv({
  base: `
    text-content-primary
    col-start-2
    grid
    justify-items-start
    gap-1
    text-sm
    [&_p]:leading-relaxed
  `
});
function AlertDescription(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = alertDescription({
      className
    });
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <div className={t1} data-slot="alert-description" {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export { alert, alertTitle, alertDescription, Alert, AlertTitle, AlertDescription };